import React from "react";
import { useParams } from "react-router-dom";
import Coursecard from "./Coursecard";
import { universities } from "./universities";

export default function Coursefilter() {

  const { courseName } = useParams();

  /* FILTERED COURSES */
  let filteredCourses = [];

  universities.forEach((uni) => {

    uni.courses.forEach((course) => {

      if (course.title === courseName) {

        filteredCourses.push({
          ...course,

          // University ka name course ke andar add kar rahe hain
          universityName: uni.university,

        });

      }

    });

  });


  return (

    <div
      className="container-fluid py-5"
      style={{
        background: "#f5f5f5",
      }}
    >

      <div className="container">

        {/* PAGE TITLE */}
        <h1 className="text-center fw-bold mb-5">

          {courseName} Programs

        </h1>


        {/* COURSE CARDS */}
        <div className="row g-4">

          {

            filteredCourses.map((course, index) => (

              <div
                className="col-lg-3 col-md-6"
                key={index}
              >

                <Coursecard course={course} />

              </div>

            ))

          }

        </div>

      </div>

    </div>

  );
}